/* eslint-disable no-var */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-namespace */
import { cookieUtil, deviceUtil, pageUtil } from "@repo/lib-common";
import { PageAdsBuilder } from "./src/ads/pageAdsBuilder";
import { DomainTagGlobalType } from "./src/domain/domainTag";
import { TargetingMap } from "./src/ads/googleTypes";
import { CountryEnum } from "./countryEnum";
import { ensureDomainTag } from "./src/main";
import { PageAdsBuilderForSpecialUseCases } from "./src/ads/pageAdsBuilderForSpecialUseCases";


export { }
export interface AdsConf {
    isEnabled: boolean;
    targetingMap: TargetingMap;
    //isSecure:boolean;
}

export class DomainPageClient {
    adsBuilder?: PageAdsBuilderForSpecialUseCases | PageAdsBuilder;
    device?: deviceUtil.DeviceTypeInfo;
    pageType?: pageUtil.PageTypeEnum;
    doesCookieExists = cookieUtil.cookieHelper.doesCookieExists;

}

declare global {
    interface Window {
        pbjs: any;
        googletag: any;


        domainTag: DomainTagGlobalType;
        domainClient: DomainPageClient; //late init in web app runtime
        domainAdsConfForDesktop: AdsConf; //late init in web app runtime
        domainAdsConfForMobile: AdsConf; //late init in web app runtime
        domainCountry: CountryEnum; //late init in web app build
        domainDevice: deviceUtil.DeviceTypeInfo; //late init in web app build

    }
}
//@ts-ignore
window.domainCountry = import.meta.env.VITE_COUNTRY;
//ensure google tag -->
window.googletag = window.googletag || { cmd: [] };
//ensure google tag --<

//ensure pbjs -->
window.pbjs = window.pbjs || {};
window.pbjs.que = window.pbjs.que || [];
//ensure pbjs --<

//ensure domain objects -->
window.domainDevice = new deviceUtil.DeviceTypeInfo();
window.domainTag = window.domainTag || { cmd: [] };
window.domainAdsConfForDesktop = window.domainAdsConfForDesktop || {
    isEnabled: true,
    targetingMap: {},
    isAdxEnabled: true,
} as AdsConf;

ensureDomainTag();
//ensure domain objects --<


